/*
 * @Description: 公共方法
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:29:45
 * @LastEditTime: 2022-07-18 17:36:35
 */
import CryptoJS from 'crypto-js'
import { JSEncrypt } from 'jsencrypt';

export const Scroll = function(id) {
  const getScrollTop = () => {
    let t = 0
    if (document.documentElement && document.documentElement.scrollTop) {
      t = document.documentElement.scrollTop
    } else if (document.body) {
      t = document.body.scrollTop
    }
    return t
  }
  this.EventListtener = {} //保存监听回调
  let DOM = id ? document.querySelector(id) : window
  const get = () => {
    //获取滚动条高度、距离顶部高度等
    this.scrollTop = getScrollTop()
    this.scrollHeight = document.body.scrollHeight
    this.height = document.body.clientHeight
    this.actualHeight = document.body.scrollHeight - document.body.clientHeight
    this.scrollLeft = document.body.scrollLeft
    this.width = document.body.clientWidth
    return this
  }
  /**
   * 设置滚动条到指定高度
   * top:指定高度
   * speed:默认80，数值越大，滚动越快
   * cel:指定元素的滚动条
   * */
  const set = (top, speed = 80) => {
    var position = get()
    let start = position.scrollTop //当前开始距离
    window.scrollTo({
      top: top,
      behavior: 'smooth',
    })
  }
  const on = (callback, uid) => {
    Object.assign(this.EventListtener, {
      [uid]: () => {
        callback(get())
      },
    })
    DOM.addEventListener('scroll', this.EventListtener[uid])
  }
  const destroyed = (uid) => {
    DOM.removeEventListener('scroll', this.EventListtener[uid])
  }

  const stopMouseScroll = function(e) {
    e = e || window.events
    if (e.preventDefault) {
      e.preventDefault()
      e.stopPropagation()
    } else {
      e.cancelBubble = true
      e.returnValue = false
    }
  }
  const stop = (s) => {
    if (s) {
      window.addEventListener('mousewheel', stopMouseScroll, {
        passive: false,
      })
    } else {
      window.removeEventListener('mousewheel', stopMouseScroll, {
        passive: false,
      })
    }
  }
  return {
    get,
    set,
    on,
    stop,
    destroyed,
  }
}
/**
 * 获取屏幕尺寸
 * */
export const getScreenSize = function() {
  let scroll = new Scroll()
  const width = scroll.get().width
  console.log(width, scroll.get())
  return {
    width,
    mobile: width <= 768,
  }
}
/**
 * 获取当前位置经纬度
 * */
export const getLLPosition = (callback) => {
  console.log('geolocation' in navigator)
  if ('geolocation' in navigator) {
    var geo_options = {
      enableHighAccuracy: true,
      maximumAge: 0,
      timeout: 6000,
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        // 获取到当前位置经纬度
        var lng = pos.coords.longitude
        var lat = pos.coords.latitude
        callback(lng, lat)
      },
      (err) => {
        callback('116.521383', '39.782209')
      },
      geo_options
    )
  } else {
    alert('Browser didnt support geolocation')
  }
}

// 重写localStorage
export const rewriteStorage = (code) => {
  var localStorageMock = () => {
    var storage = window.localStorage
    return {
      setItem: (key, value) => {
        var setItemEvent = new Event('setItemEvent')
        const newKey = key + '_' + code
        var oldValue = storage[newKey]
        setItemEvent.key = newKey
        if (oldValue != value) {
          // 新旧值深度判断，派发监听事件
          setItemEvent.newValue = value
          setItemEvent.oldValue = oldValue
          window.dispatchEvent(setItemEvent)
          storage[newKey] = value
          return true
        }
        return false
      },
      getItem: (key) => {
        const newKey = key + '_' + code
        return storage[newKey]
      },
      removeItem: (key) => {
        const newKey = key + '_' + code
        storage[newKey] = null
        return true
      },
      clear: function() {
        storage.clear()
        return true
      },
    }
  }

  Object.defineProperty(window, 'localStorage', {
    value: localStorageMock(),
    writable: true,
  })
}

export const setConfirmTop = (top) => {
 
  const c = document.querySelector(".ant-modal-confirm");
  if(c){
    return
  }
  const s = document.getElementById('patientModalConfirm')
  if (s) {
    document.head.removeChild(s)
  }
  let style = document.createElement('style')
  style.id = 'patientModalConfirm'
  style.innerHTML = `
  .ant-modal-confirm .ant-modal{
            top:${top}px!important
          }
        `
  style.setAttribute('type', 'text/css')
  document.head.append(style)
}

/* DES解密
  ciphertext:密文
  key:密钥
*/
export const decryptByDES = (ciphertext = '', key) => {
  var keyHex = CryptoJS.enc.Utf8.parse(key);
  var decrypted = CryptoJS.DES.decrypt({
    ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
  }, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}
/* DES加密
  ciphertext:密文
  key:密钥
*/
export const encryptByDES = (ciphertext = '', key) => {
  var keyHex = CryptoJS.enc.Utf8.parse(key);
  var encrypted = CryptoJS.DES.encrypt(ciphertext, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

// 二代身份证校验方法
export const checkIdNo = (value) => {
  const p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  const q = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$/;
  if (value && value.length === 18 && p.test(value)) {
    const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const parity = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const code = value.substring(17);
    let sum = 0;
    for (let i = 0; i < 17; i += 1) {
      sum += value[i] * factor[i];
    }
    if (parity[sum % 11] === code.toUpperCase()) {
      return true;
    }
  }
  if (value && value.length === 15 && q.test(value)) {
    return true;
  }
  return false;
};
// 外国人永久居留证校验方法
export const checkForeignerIdNo = (value) => {
  const p = /(^[A-Za-z0-9]{15}|^[A-Za-z0-9]{18})$/;
  if (p.test(value)) {
    return true;
  }
  return false;
};
// 验证手机号码格式
export const checkPhoneNo = (value) => {
  const regPhone = /^1[0-9]{10}$/;
  if (!regPhone.test(value)) {
    return false;
  }
  return true;
};
// 验证字母数字
export const checkIdTypes = (value) => {
  const regType = /^[A-Za-z0-9]+$/;
  if (!regType.test(value)) {
    return false;
  }
  return true;
};

export const isComplexityMatches = (value) => {
  // '必须包含大写字母、小写字母、数字、特殊字符至少三种'
  const regex = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]/
  if (regex.test(value)) {
    return true;
  } else {
    return false;
  }
};

export const validatePass2 = (value1, value2) => {
  // '两次密码输入不一致!'
  if (value1 !== value2) {
    return false;
  } else {
    return true;
  }
};

// RSA加密
export const setEncrypt = (msg, publicKey) => {
  let jsencrypt = new JSEncrypt({});
  jsencrypt.setPublicKey(publicKey);
  return jsencrypt.encrypt(msg);
}
